module.exports = __webpack_public_path__ + "static/media/IS HIPAA Notice of Privacy Policies.44f4e7ed.pdf";